import { z } from 'zod';
import { isoDateTimeSchema, uuidSchema } from './common';

// COPPA verifiable parent consent record — per plan §6.5.
// Required before a dancer (13+) can have standalone login enabled.

export const COPPA_CONSENT_VERSION = '2026-01-01' as const;

export const coppaConsentInputSchema = z.object({
  family_id: uuidSchema,
  dancer_id: uuidSchema,
  parent_user_id: uuidSchema,
  // Typed-name acknowledgement — proves a human took the action.
  parent_typed_name: z.string().trim().min(2).max(200),
  consent_version: z.string().min(1).default(COPPA_CONSENT_VERSION),
  // IP & UA captured server-side from the request — not user-supplied.
  ip_address: z.string().min(2).max(64),
  user_agent: z.string().min(2).max(512),
});
export type CoppaConsentInput = z.infer<typeof coppaConsentInputSchema>;

export const coppaConsentSchema = coppaConsentInputSchema.extend({
  id: uuidSchema,
  occurred_at: isoDateTimeSchema,
});
export type CoppaConsentRecord = z.infer<typeof coppaConsentSchema>;
